module.exports = __webpack_public_path__ + "img/message-avatar-tree.7045ee4b.svg";